module.exports = __webpack_public_path__ + "img/1.34082a8e.png";